import * as qs from 'qs';

export const languages = {
  en: 'English',
  nl: 'Nederlands',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
};

for (const key of Object.keys(languages)) {
  if (key !== 'en') {
    require(`moment/locale/${key}`);
  }
}

export const url = {
  apx: process.env.REACT_APP_TARGET_HOST,
  pages: process.env.REACT_APP_URL,
  images: `${process.env.REACT_APP_URL}/assets/images`,
};

export function getMessages(language: string) {
  try {
    return require(`../../locales/${language}.json`);
  } catch (err) {
    return require('../../locales/en.json');
  }
}

export function parseUrl(search: string) {
  return qs.parse(search, { ignoreQueryPrefix: true });
}
